<script setup>
import { computed } from 'vue';
import { AGE_META, GENDER_META, AFFINITY_META } from '../utils/brazilianStates';

const props = defineProps({
  data: { type: Object, default: () => ({ age: [], gender: [], affinity: [] }) },
});

const facets = computed(() => [
  {
    key: 'age',
    title: 'Faixa etária',
    icon: 'i-lucide-users',
    items: props.data.age || [],
    meta: AGE_META,
  },
  {
    key: 'gender',
    title: 'Gênero',
    icon: 'i-lucide-venus-and-mars',
    items: props.data.gender || [],
    meta: GENDER_META,
  },
  {
    key: 'affinity',
    title: 'Afinidade política',
    icon: 'i-lucide-vote',
    items: props.data.affinity || [],
    meta: AFFINITY_META,
  },
]);

const totalOf = arr => arr.reduce((s, i) => s + (i.total || 0), 0);
const pct = (n, total) => (total ? Math.round((n / total) * 100) : 0);
</script>

<template>
  <div class="grid grid-cols-1 gap-3 lg:grid-cols-3">
    <div
      v-for="f in facets"
      :key="f.key"
      class="rounded-xl border border-n-strong/40 bg-n-background p-4"
    >
      <div class="mb-3 flex items-center gap-2">
        <span :class="f.icon" class="size-4 text-n-slate-11" />
        <h3 class="text-sm font-bold text-n-slate-12">{{ f.title }}</h3>
      </div>

      <div v-if="f.items.length" class="space-y-1.5">
        <div
          v-for="item in f.items"
          :key="item.value"
          class="flex items-center gap-2"
        >
          <span
            :class="[f.meta[item.value]?.color || 'bg-n-slate-2 text-n-slate-12', 'min-w-[92px] rounded px-2 py-0.5 text-[11px] font-medium']"
          >
            {{ f.meta[item.value]?.label || item.value }}
          </span>
          <div class="relative h-3 flex-1 overflow-hidden rounded bg-n-slate-2">
            <div
              class="absolute inset-y-0 left-0 bg-blue-500"
              :style="`width: ${pct(item.total, totalOf(f.items))}%`"
            />
          </div>
          <span class="w-10 text-right text-[11px] font-semibold text-n-slate-12">
            {{ item.total }}
          </span>
          <span class="w-10 text-right text-[10px] text-n-slate-11">
            {{ pct(item.total, totalOf(f.items)) }}%
          </span>
        </div>
      </div>

      <div v-else class="py-6 text-center text-[11px] text-n-slate-11">
        Sem dados suficientes.
      </div>
    </div>
  </div>
</template>
